import React, {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import toast from "react-hot-toast";

import AdvertisementForm from "../components/advertisements/AdvertisementForm";

import {
  advertisementsApi,
} from "../api/advertisementsApi";

import type {
  AdvertisementMediaChanges,
  CreateAdvertisementInput,
} from "../types/advertisement.types";

import {
  useAuth,
} from "../contexts/AuthContext";

import "../screenstyles/Advertisements.css";

const AddAdvertisement:
React.FC = () => {
  const navigate =
    useNavigate();

  const {
    hasPermission,
  } = useAuth();

  const [
    submitting,
    setSubmitting,
  ] =
    useState(false);

  if (
    !hasPermission(
      "advertisements.create",
    )
  ) {
    return (
      <div className="advertisement-access-denied">
        <div className="advertisement-access-denied-card">
          <h2 className="advertisement-access-denied-title">
            لا تملك صلاحية إضافة إعلان.
          </h2>
        </div>
      </div>
    );
  }

  const handleSubmit =
    async (
      input:
        CreateAdvertisementInput,

      media:
        AdvertisementMediaChanges,
    ) => {
      let createdId:
        string | null =
          null;

      try {
        setSubmitting(
          true,
        );

        /**
         * 1. Create advertisement draft.
         */
        const created =
          await advertisementsApi
            .create(
              input,
            );

        createdId =
          created.id;

        /**
         * 2. Upload mandatory main image.
         */
        if (
          !media.mainImageFile
        ) {
          throw new Error(
            "Main advertisement image is required",
          );
        }

        await advertisementsApi
          .uploadMainImage(
            created.id,

            media.mainImageFile,
          );

        /**
         * 3. Upload optional mobile image.
         */
        if (
          media.mobileImageFile
        ) {
          await advertisementsApi
            .uploadMobileImage(
              created.id,

              media.mobileImageFile,
            );
        }

        toast.success(
          "تم إنشاء الإعلان ورفع الصور بنجاح",
        );

        navigate(
          `/advertisements/${created.id}`,
        );
      } catch (
        error
      ) {
        console.error(
          error,
        );

        /**
         * Advertisement may already exist as draft.
         * Keep it instead of losing entered data.
         */
        if (
          createdId
        ) {
          toast.error(
            "تم إنشاء مسودة الإعلان، لكن تعذر إكمال رفع الصور. يمكنك إعادة المحاولة من صفحة التعديل.",
          );

          navigate(
            `/advertisements/${createdId}/edit`,
          );

          return;
        }

        toast.error(
          "تعذر إنشاء الإعلان",
        );
      } finally {
        setSubmitting(
          false,
        );
      }
    };

  return (
    <main
      className="
        advertisement-page
        advertisement-page-create
      "
      dir="rtl"
    >
      <header className="advertisement-page-header">
        <div className="advertisement-page-header-content">
          <span className="advertisement-page-eyebrow">
            إدارة الإعلانات
          </span>

          <h1 className="advertisement-page-title">
            إضافة إعلان جديد
          </h1>

          <p className="advertisement-page-description">
            أنشئ الإعلان وارفع صوره
            مباشرة من جهازك وحدد
            الاستهداف واللغة والجدولة
            ومكان الظهور.
          </p>
        </div>

        <div className="advertisement-page-header-actions">
          <button
            type="button"
            className="advertisement-page-back-btn"
            onClick={() =>
              navigate(
                "/advertisements",
              )
            }
          >
            رجوع إلى الإعلانات
          </button>
        </div>
      </header>

      <AdvertisementForm
        submitLabel="إنشاء الإعلان"
        submitting={
          submitting
        }
        onSubmit={
          handleSubmit
        }
        onCancel={() =>
          navigate(
            "/advertisements",
          )
        }
      />
    </main>
  );
};

export default AddAdvertisement;